export default "__VITE_ASSET__Db0FuqR3__"